module.exports = __webpack_public_path__ + "assets/popup-up-left-139164ca.png";